// src/main.ts
// Al final de src/main.ts
import { registerSW } from "virtual:pwa-register";

document.addEventListener("DOMContentLoaded", () => {
  const cookiesNaming = {
    adblock: "yaconic_adblock",
    theme: "yaconic_theme",
    lang: "yaconic_lang",
    acceptCookies: "cookiesAgreement",
    IAmOfLegalAge: "IAmOfLegalAge",
    stickyAdsClosed: "yaconic_sticky_ads_closed",
  };

  const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift();
  };

  const setCookie = (name: string, value: string, days: number) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  };

  // --- 0. Mobile Menu Toggle ---
  const menuToggle = document.getElementById(
    "menu-toggle",
  ) as HTMLButtonElement | null;
  const menuOverlay = document.getElementById(
    "mobile-menu-overlay",
  ) as HTMLElement | null;
  const menuBackdrop = document.getElementById(
    "menu-backdrop",
  ) as HTMLElement | null;
  const menuDrawer = document.getElementById(
    "menu-drawer",
  ) as HTMLElement | null;
  const hamburgerLines = document.querySelectorAll(".hamburger-line");
  const closeMenuBtn = document.getElementById(
    "close-menu-btn",
  ) as HTMLButtonElement | null;

  const closeMenu = () => {
    menuBackdrop?.classList.add("opacity-0");
    menuDrawer?.classList.add("-translate-x-full");

    setTimeout(() => {
      menuOverlay?.classList.add("invisible");
    }, 300);

    menuToggle?.setAttribute("aria-expanded", "false");
    if (hamburgerLines.length === 3) {
      (hamburgerLines[0] as HTMLElement).style.transform = "none";
      (hamburgerLines[1] as HTMLElement).style.opacity = "1";
      (hamburgerLines[2] as HTMLElement).style.transform = "none";
    }
    document.body.style.overflow = "";
  };

  const openMenu = () => {
    menuOverlay?.classList.remove("invisible");

    // Permitir display antes de animar
    requestAnimationFrame(() => {
      menuBackdrop?.classList.remove("opacity-0");
      menuDrawer?.classList.remove("-translate-x-full");
    });

    menuToggle?.setAttribute("aria-expanded", "true");
    if (hamburgerLines.length === 3) {
      (hamburgerLines[0] as HTMLElement).style.transform =
        "translateY(8px) rotate(45deg)";
      (hamburgerLines[1] as HTMLElement).style.opacity = "0";
      (hamburgerLines[2] as HTMLElement).style.transform =
        "translateY(-8px) rotate(-45deg)";
    }
    document.body.style.overflow = "hidden";
  };

  if (menuToggle && menuOverlay) {
    menuToggle.addEventListener("click", () => {
      const isClosed = menuOverlay.classList.contains("invisible");
      if (isClosed) {
        openMenu();
      } else {
        closeMenu();
      }
    });

    closeMenuBtn?.addEventListener("click", closeMenu);
    menuBackdrop?.addEventListener("click", closeMenu);
  }

  // --- 0.5. Mobile Submenu Interactivity (main-navigation) ---
  const navItemsWithSubmenu = document.querySelectorAll("#main-navigation li.relative");
  
  navItemsWithSubmenu.forEach((item) => {
    const link = item.querySelector("a");
    
    if (link) {
      link.addEventListener("click", (e) => {
        // Ejecutar comportamiento solo en móviles (pantallas pequeñas)
        if (window.innerWidth < 768) {
          const isActive = item.classList.contains("is-active");
          
          if (!isActive) {
            // Prevenir la navegación inicial
            e.preventDefault();
            
            // Cerrar otros submenús abiertos
            navItemsWithSubmenu.forEach((otherItem) => {
              otherItem.classList.remove("is-active");
            });
            
            // Activar el submenú actual
            item.classList.add("is-active");
          }
        }
      });
    }
  });

  // Cerrar submenús al hacer clic/tap en cualquier otra parte
  document.addEventListener("click", (e) => {
    if (window.innerWidth < 768) {
      const target = e.target as HTMLElement;
      if (!target.closest("#main-navigation")) {
        navItemsWithSubmenu.forEach((item) => {
          item.classList.remove("is-active");
        });
      }
    }
  });

  // --- 1.5. Full Screen Search ---
  const searchControlBtn = document.getElementById("YaconicSearchControl");
  const searchOverlay = document.getElementById("search-overlay");
  const closeSearchBtn = document.getElementById("close-search-btn");
  const searchInput = document.getElementById(
    "search-input",
  ) as HTMLInputElement | null;
  const voiceSearchBtn = document.getElementById("voice-search-btn");
  const voiceSearchStatus = document.getElementById("voice-search-status");
  const voiceSearchSubmit = document.getElementById("voice-search-submit");

  if (searchControlBtn && searchOverlay && closeSearchBtn && searchInput) {
    searchControlBtn.addEventListener("click", () => {
      searchOverlay.classList.remove("-translate-y-full");
      searchOverlay.classList.add("translate-y-0");
      document.body.style.overflow = "hidden"; // Evitar scroll de fondo
      setTimeout(() => searchInput.focus(), 300); // Focus después de la animación
    });

    closeSearchBtn.addEventListener("click", () => {
      searchOverlay.classList.remove("translate-y-0");
      searchOverlay.classList.add("-translate-y-full");
      document.body.style.overflow = "";
    });

    // Voice Search usign SpeechRecognition API
    if (voiceSearchBtn && voiceSearchStatus) {
      const SpeechRecognition =
        (window as any).SpeechRecognition ||
        (window as any).webkitSpeechRecognition;

      if (SpeechRecognition) {
        const recognition = new SpeechRecognition();
        recognition.lang = "es-MX"; // Español de México por defecto
        recognition.continuous = false;
        recognition.interimResults = false;

        recognition.onstart = () => {
          voiceSearchStatus.textContent = "Escuchando...";
          voiceSearchStatus.classList.remove("hidden");
          voiceSearchBtn.classList.add("text-yaconic-salmon");
        };

        recognition.onresult = (event: any) => {
          const transcript = event.results[0][0].transcript;
          searchInput.value = transcript;
          // Opcional: Podrías hacer submit automáticamente después de reconocer el texto
          const searchForm = document.getElementById(
            "search-form",
          ) as HTMLFormElement;
          if (searchForm && voiceSearchSubmit) voiceSearchSubmit.click();
        };

        recognition.onspeechend = () => {
          recognition.stop();
          voiceSearchStatus.classList.add("hidden");
          voiceSearchBtn.classList.remove("text-yaconic-salmon");
        };

        recognition.onerror = (event: any) => {
          console.error("Error en reconocimiento de voz", event.error);
          voiceSearchBtn.classList.remove("text-yaconic-salmon");
          voiceSearchStatus.textContent = "Error: " + event.error;
          voiceSearchStatus.classList.remove("hidden");
          setTimeout(() => voiceSearchStatus.classList.add("hidden"), 3000);
        };

        voiceSearchBtn.addEventListener("click", () => {
          try {
            recognition.start();
          } catch (e) {
            console.error(e);
          }
        });
      } else {
        voiceSearchBtn.style.display = "none"; // Ocultar si el navegador no lo soporta
        console.warn("API de Web Speech no soportada en este navegador.");
      }
    }
  }

  // --- 2. Dark/Light Mode Switch ---
  const themeSwitch = document.querySelector(
    ".theme-switch",
  ) as HTMLButtonElement | null;
  const sunIcon = document.querySelector(".sun-icon") as SVGElement | null;
  const moonIcon = document.querySelector(".moon-icon") as SVGElement | null;

  // Determinar preferencia del sistema (OPCIONAL) o por defecto light original.
  // const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const root = document.documentElement;
  const theme = getCookie(cookiesNaming.theme);

  const updateBrowserThemeColor = () => {
    const isDark = document.documentElement.classList.contains("dark");
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute("content", isDark ? "#09090b" : "#ffffff");
    }
  };

  if (theme) {
    root.classList.add(theme);
  }

  if (themeSwitch && sunIcon && moonIcon) {
    themeSwitch.addEventListener("click", () => {
      if (root.classList.contains("dark")) {
        root.classList.remove("dark");
        sunIcon.classList.remove("hidden");
        moonIcon.classList.add("hidden");
      } else {
        root.classList.add("dark");
        sunIcon.classList.add("hidden");
        moonIcon.classList.remove("hidden");
      }

      updateBrowserThemeColor();

      setCookie(
        cookiesNaming.theme,
        root.classList.contains("dark") ? "dark" : "light",
        365,
      );
    });
  }

  // --- 3. Interaction Hover en Social Proof (Opcional por JS si CSS no basta) ---
  // Manejado puramente en CSS (:hover .number { color: var(--color-salmon); })

  // --- 4. AdBlock Detection ---
  const detectAdBlock = () => {
    const ad = document.createElement("div");
    // Clases típicamente bloqueadas por listas como EasyList o AdBlockPlus
    ad.className = "ad-banner adsbox doubleclick ad-placement";
    ad.style.position = "absolute";
    ad.style.top = "-999px";
    ad.style.left = "-999px";
    ad.style.height = "1px";
    ad.style.width = "1px";
    document.body.appendChild(ad);

    // Delay corto para permitir que la extensión actúe sobre el DOM
    setTimeout(() => {
      // Usar requestAnimationFrame para aislar la lectura de offsetHeight y evitar forced reflow
      requestAnimationFrame(() => {
        const isBlocked =
          ad.offsetHeight === 0 || window.getComputedStyle(ad).display === "none";
        if (isBlocked) {
          const popup = document.getElementById("adblock-popup");
          if (popup) {
            document.body.style.overflow = "hidden"; // Bloquear scroll original
            popup.classList.remove("hidden"); // Mostrar popup
          }
        }
        ad.remove(); // Limpiar el DOM
      });
    }, 500); // 500ms usualmente son suficientes
  };

  // Ejecutamos en cliente cuando el DOM está listo
  detectAdBlock();

  const closeAdBlockBtn = document.getElementById("close-adblock-btn");
  if (closeAdBlockBtn) {
    closeAdBlockBtn.addEventListener("click", () => {
      window.location.reload();
    });
  }

  // --- 5. Cookie Policy Banner ---
  const cookieBanner = document.getElementById("cookie-banner");
  const acceptCookiesBtn = document.getElementById("accept-cookies-btn");
  const cookieAccepted = getCookie("cookiesAgreement");

  if (cookieBanner && acceptCookiesBtn) {
    if (!cookieAccepted) {
      // Mostrar el banner con un ligero retraso para transición suave
      setTimeout(() => {
        cookieBanner.classList.remove("hidden");
        // Timeout extra para que el navegador procese el remove hidden antes de animar
        setTimeout(() => {
          cookieBanner.classList.remove("translate-y-full");
        }, 50);
      }, 1000); // 1 segundo después de cargar la página
    }

    acceptCookiesBtn.addEventListener("click", () => {
      // Guardar la cookie de aceptación por 1 año (365 días)
      setCookie("cookiesAgreement", "acuerdo", 365);

      // Animar salida
      cookieBanner.classList.add("translate-y-full");

      // Ocultar después de la animación (500ms alinea con duration-500 en Tailwind)
      setTimeout(() => {
        cookieBanner.classList.add("hidden");
      }, 500);
    });
  }

  // --- 6. Age Gate Popup ---
  const isAdultPage = document.getElementById("is-adult-page");
  const ageGatePopup = document.getElementById("age-gate-popup");
  const acceptAgeBtn = document.getElementById("accept-age-btn");
  const rejectAgeBtn = document.getElementById("reject-age-btn");
  // Verificamos si la cookie explícitamente existe y es 'true'
  const isOfLegalAge = getCookie(cookiesNaming.IAmOfLegalAge) === "true";

  if (isAdultPage && ageGatePopup && acceptAgeBtn && rejectAgeBtn) {
    if (!isOfLegalAge) {
      // Quitar scroll y mostrar popup
      document.body.style.overflow = "hidden";
      ageGatePopup.classList.remove("hidden");
    }

    acceptAgeBtn.addEventListener("click", () => {
      // Guardamos la cookie de mayoría de edad por 365 días
      setCookie(cookiesNaming.IAmOfLegalAge, "true", 365);
      // Restauramos scroll y ocultamos popup
      document.body.style.overflow = "";
      ageGatePopup.classList.add("hidden");
    });

    rejectAgeBtn.addEventListener("click", () => {
      // Opcional: Redirigir a un sitio seguro (ej. Google o Disney)
      window.location.href = "https://www.yaconic.com";
    });
  }
  // --- 7. Text To Speech (Beta) ---
  const ttsButton = document.getElementById(
    "tts-button",
  ) as HTMLButtonElement | null;
  const articleContent = document.querySelector(
    ".article--content",
  ) as HTMLElement | null;
  const ttsPlayIcon = document.querySelector(
    ".tts-play-icon",
  ) as SVGElement | null;
  const ttsPauseIcon = document.querySelector(
    ".tts-pause-icon",
  ) as SVGElement | null;
  const ttsText = document.querySelector(".tts-text") as HTMLSpanElement | null;

  let utterance: SpeechSynthesisUtterance | null = null;
  let isPlaying = false;
  let isPaused = false;
  let availableVoices: SpeechSynthesisVoice[] = [];
  const synth = window.speechSynthesis;

  // Load voices as soon as possible
  const loadVoices = () => {
    availableVoices = synth.getVoices();
  };

  // In Chrome/Safari, voices load asynchronously.
  if (speechSynthesis.onvoiceschanged !== undefined) {
    speechSynthesis.onvoiceschanged = loadVoices;
  }
  // Try immediately in case they are already loaded
  loadVoices();

  if (ttsButton && articleContent && "speechSynthesis" in window) {
    // Store chunks of text and their corresponding DOM elements
    interface TextChunk {
      element: HTMLElement;
      text: string;
      startIndex: number;
      endIndex: number;
    }

    let textChunks: TextChunk[] = [];
    let fullTextToRead = "";
    let currentlyHighlightedElement: HTMLElement | null = null;
    let currentChunkIndex = 0;
    let cancelTimeout: any = null;

    const clearHighlight = () => {
      if (currentlyHighlightedElement) {
        currentlyHighlightedElement.style.backgroundColor = "";
        currentlyHighlightedElement.style.transition = "";
        currentlyHighlightedElement = null;
      }
    };

    // Function to extract text and map it to elements recursively
    const buildTextChunks = (rootElement: Element) => {
      textChunks = [];
      fullTextToRead = "";
      let currentIndex = 0;

      const traverse = (element: Element) => {
        const children = Array.from(element.children);

        if (
          children.length === 0 ||
          ["P", "H1", "H2", "H3", "H4", "H5", "H6", "LI"].includes(
            element.tagName,
          )
        ) {
          // Valid block elements we want to read and highlight
          if (
            ["P", "H1", "H2", "H3", "H4", "H5", "H6", "LI"].includes(
              element.tagName,
            )
          ) {
            const text = (element.textContent || "").trim() + ". ";
            if (text.length > 2) {
              // Ignore empty or whitespace-only nodes
              textChunks.push({
                element: element as HTMLElement,
                text: text,
                startIndex: currentIndex,
                endIndex: currentIndex + text.length,
              });
              fullTextToRead += text;
              currentIndex += text.length;
            }
            return; // Stop traversing children if we treat this as a single readable block
          }
        }

        // Iterate over children if it's a wrapper like a div or ul/ol
        children.forEach((child) => traverse(child));
      };

      traverse(rootElement);
    };

    const updateUI = (state: "play" | "pause" | "stop") => {
      if (!ttsPlayIcon || !ttsPauseIcon || !ttsText) return;

      if (state === "play") {
        ttsText.textContent = "Pausar";
        ttsPlayIcon.classList.add("hidden");
        ttsPauseIcon.classList.remove("hidden");

        // Re-apply highlight if we resumed
        if (currentlyHighlightedElement && textChunks.length > 0) {
          currentlyHighlightedElement.style.backgroundColor =
            "rgba(255, 127, 108, 0.1)";
        }
      } else if (state === "pause") {
        ttsText.textContent = "Reanudar";
        ttsPlayIcon.classList.remove("hidden");
        ttsPauseIcon.classList.add("hidden");

        // Keep the reference but visually clear it while paused
        if (currentlyHighlightedElement) {
          currentlyHighlightedElement.style.backgroundColor = "";
        }
      } else if (state === "stop") {
        ttsText.textContent = "Escuchar artículo";
        ttsPlayIcon.classList.remove("hidden");
        ttsPauseIcon.classList.add("hidden");
        clearHighlight();
        textChunks = [];
      }
    };

    const playChunk = (index: number) => {
      if (index < 0 || index >= textChunks.length) {
        // Finished all chunks
        isPlaying = false;
        isPaused = false;
        updateUI("stop");
        return;
      }

      currentChunkIndex = index;
      const chunk = textChunks[index];

      // Highlight paragraph visual feedback
      clearHighlight();
      currentlyHighlightedElement = chunk.element;
      currentlyHighlightedElement.style.transition = "background-color 0.3s ease";
      currentlyHighlightedElement.style.backgroundColor = "rgba(255, 127, 108, 0.1)";

      // Create new utterance for this specific chunk
      utterance = new SpeechSynthesisUtterance(chunk.text);

      // Load voices if not already cached
      if (availableVoices.length === 0) {
        availableVoices = synth.getVoices();
      }

      let selectedVoice = null;
      let preferredVoiceNames = [
        "Monica",
        "Paulina",
        "Google español de Estados Unidos",
        "Google español",
      ];

      const ttsBtnEl = document.getElementById("tts-button");
      const ttsBtnAttr = ttsBtnEl ? ttsBtnEl.getAttribute("data-preferredvoices") : null;
      if (ttsBtnAttr && ttsBtnAttr.trim() !== "") {
        const parsedVoices = ttsBtnAttr
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v.length > 0);
        if (parsedVoices.length > 0) {
          preferredVoiceNames = parsedVoices;
        }
      }

      for (const name of preferredVoiceNames) {
        selectedVoice = availableVoices.find((v) => v.name.includes(name));
        if (selectedVoice) break;
      }

      if (!selectedVoice) {
        selectedVoice =
          availableVoices.find(
            (v) =>
              v.lang === "es-MX" && v.name.toLowerCase().includes("female"),
          ) ||
          availableVoices.find((v) => v.lang.startsWith("es-MX")) ||
          availableVoices.find((v) => v.lang.startsWith("es"));
      }

      if (selectedVoice) {
        utterance.voice = selectedVoice;
        utterance.lang = selectedVoice.lang;
      } else {
        const navLang = navigator.language.replace("_", "-");
        utterance.lang = navLang.startsWith("es") ? navLang : "es-MX";
      }

      utterance.rate = 1.0;
      utterance.pitch = 1.0;

      utterance.onend = () => {
        // Only trigger the next chunk if we are still actively playing (not paused/stopped)
        if (isPlaying && !isPaused) {
          playChunk(index + 1);
        }
      };

      utterance.onerror = (e) => {
        // Ignore expected cancellation/interruptions when user pauses or stops
        if (e.error === "interrupted" || e.error === "canceled") {
          return;
        }
        console.error("TTS Error:", e);
        isPlaying = false;
        isPaused = false;
        updateUI("stop");
      };

      synth.speak(utterance);
    };

    const pauseSpeech = () => {
      isPaused = true;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (isMobile) {
        // On mobile, native pause is extremely bug-prone. We cancel speech, and playChunk will start over from currentChunkIndex on resume
        synth.cancel();
      } else {
        synth.pause();
      }
      updateUI("pause");
    };

    const resumeSpeech = () => {
      isPaused = false;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (isMobile) {
        // For mobile, cancel() was called, so we trigger a delayed speak for safety
        synth.cancel();
        if (cancelTimeout) clearTimeout(cancelTimeout);
        cancelTimeout = setTimeout(() => {
          playChunk(currentChunkIndex);
          updateUI("play");
        }, 150);
      } else {
        synth.resume();
        updateUI("play");
      }
    };

    ttsButton.addEventListener("click", () => {
      if (isPlaying && !isPaused) {
        pauseSpeech();
      } else if (isPlaying && isPaused) {
        resumeSpeech();
      } else {
        // Start new reading session
        isPlaying = true;
        isPaused = false;
        synth.cancel();
        clearHighlight();

        buildTextChunks(articleContent);

        if (textChunks.length === 0) {
          isPlaying = false;
          return;
        }

        // Delay starting the first chunk to let synth.cancel() finish its cleanup cleanly
        if (cancelTimeout) clearTimeout(cancelTimeout);
        cancelTimeout = setTimeout(() => {
          playChunk(0);
          updateUI("play");
        }, 250);
      }
    });

    // Handle cases where the user navigates away or unloads the page
    window.addEventListener("beforeunload", () => {
      window.speechSynthesis.cancel();
      if (cancelTimeout) clearTimeout(cancelTimeout);
    });
  }

  // --- 8. Sticky Ad Banner ---
  const stickyBanner = document.getElementById("sticky-ads-banner");
  const toggleBannerBtn = document.getElementById("toggle-sticky-banner");
  const closeBannerBtn = document.getElementById("close-sticky-banner");
  const toggleIcon = document.getElementById("toggle-sticky-icon");
  const bannerSizeText = document.getElementById("banner-size-text");

  const stickyBannerClosed = getCookie("yaconic_sticky_ads_closed");

  if (stickyBannerClosed === "true") {
    if (stickyBanner) {
      stickyBanner.style.display = "none";
    }
  } else if (stickyBanner && toggleBannerBtn && closeBannerBtn && toggleIcon) {
    let isBannerMinified = false;
    let userManuallyToggled = false;

    // Configuración inicial de las alturas
    const MAX_HEIGHT = 236;
    const MIN_HEIGHT = 100;

    // Función para actualizar la UI del banner
    const updateBannerState = (minify: boolean) => {
      isBannerMinified = minify;
      if (isBannerMinified) {
        stickyBanner.style.height = `${MIN_HEIGHT}px`;
        toggleIcon.style.transform = "rotate(180deg)"; // Flecha hacia arriba
        if (bannerSizeText) bannerSizeText.innerText = `970x${MIN_HEIGHT}`;
      } else {
        stickyBanner.style.height = `${MAX_HEIGHT}px`;
        toggleIcon.style.transform = "rotate(0deg)"; // Flecha hacia abajo
        if (bannerSizeText) bannerSizeText.innerText = `970x${MAX_HEIGHT}`;
      }
    };

    // Event listener para el control por scroll (optimizado con rAF y passive listener)
    let isScrollTicking = false;
    window.addEventListener(
      "scroll",
      () => {
        // Si el usuario ya hizo click manual, no modificamos en scroll
        if (userManuallyToggled) return;

        if (!isScrollTicking) {
          requestAnimationFrame(() => {
            const scrollY = window.scrollY || window.pageYOffset;

            if (scrollY > 100 && !isBannerMinified) {
              updateBannerState(true);
            } else if (scrollY <= 100 && isBannerMinified) {
              updateBannerState(false);
            }
            isScrollTicking = false;
          });
          isScrollTicking = true;
        }
      },
      { passive: true },
    );

    // Event listener para el botón toggle (Flecha)
    toggleBannerBtn.addEventListener("click", () => {
      userManuallyToggled = true; // Desactivar el auto-scroll behavior
      updateBannerState(!isBannerMinified);
    });

    // Event listener para el botón cerrar
    closeBannerBtn.addEventListener("click", () => {
      // Guardar cookie por 1 día (24 horas)
      setCookie(cookiesNaming.stickyAdsClosed, "true", 1);

      // Animar salida
      stickyBanner.style.transform = "translateY(100%)";
      setTimeout(() => {
        stickyBanner.style.display = "none";
      }, 300);
    });
  }

  if ("serviceWorker" in navigator) {
    registerSW({
      onNeedRefresh() {
        console.log("Nuevo contenido disponible. Por favor, recarga.");
        // Opcional: Mostrar un micro-toast premium de 'Nueva actualización lista'
      },
      onOfflineReady() {
        console.log("El sitio está listo para usarse sin conexión a internet.");
      }
    });
  }
});
